<template>
  <div class="grey lighten-4 text-right pa-4">
    <div class="text-right" v-if="typeof totalFeeMoney === 'number'">
      <span class="mx-4">Tổng tiền thu/đóng</span>
      <span v-if="!loadingFeeMoney" class="red--text mx-4"
        >{{ totalFeeMoney ? totalFeeMoney.toLocaleString('en-US') : 0 }} VNĐ</span
      >
      <span class="mr-2 detail_text" @click="setToggleFilter" v-if="!loadingFeeMoney"
        ><router-link to="/financial-report" class="text-decoration-none font-weight-bold">
          Xem chi tiết
        </router-link></span
      >
    </div>
    <div v-else class="d-flex flex-column">
      <div class="text-right">
        <span class="mx-4">Tổng "Học phí"</span>
        <span v-if="!loadingFeeMoney" class="red--text mx-4">{{
          formatFeeMoney($_get(totalFeeMoney, 'totalAmountCen'))
        }}</span>
        <span style="width: 78.45px; display: inline-block" class="mr-2">&nbsp;</span>
      </div>
      <div class="text-right">
        <span class="mx-4">Tổng "Thu hộ/Chi hộ"</span>
        <span v-if="!loadingFeeMoney" class="red--text mx-4">{{
          formatFeeMoney($_get(totalFeeMoney, 'totalAmountDecen'))
        }}</span>
        <span style="width: 78.45px; display: inline-block" class="mr-2">&nbsp;</span>
      </div>
      <div class="text-right">
        <span class="mx-4">Tổng tiền thu/đóng</span>
        <span v-if="!loadingFeeMoney" class="red--text mx-4">{{  formatFeeMoney($_get(totalFeeMoney, 'totalAmount')) }}</span>
        <span class="mr-2 detail_text" @click="setToggleFilter" v-if="!loadingFeeMoney"
          ><router-link to="/financial-report" class="text-decoration-none font-weight-bold">
            Xem chi tiết
          </router-link></span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      totalFeeMoney: 'tuitionFeePeriod/totalFeeMoney',
      loadingFeeMoney: 'tuitionFeePeriod/loadingFeeMoney',
      toggleFilter: 'tuitionFeeReport/toggleFilter',
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapMutations('tuitionFeeReport', ['setToggleFilter']),
    formatFeeMoney(money) {
      if (!money) return 0
      return money.toLocaleString('en-US') + ' VNĐ'
    },
  },
}
</script>
<style lang="scss">
.detail_text {
  font-size: 14px;
  color: #0d47a1;
}
</style>
